import { IFormatListSelectorDialogCondition, instanceOfIFormatListSelectorDialogCondition } from "./IFormatListSelectorDialogCondition";

export interface IMultiFormatListSelectorDialogCondition extends IFormatListSelectorDialogCondition {
  isMultiSelectable: boolean;
}

export function instanceOfIMultiDepartmentListSelectorDialogCondition(instance: any): instance is IMultiFormatListSelectorDialogCondition {
  return instance
    && (instance.isMultiSelectable !== undefined)
    && instanceOfIFormatListSelectorDialogCondition(instance);
}
